import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchAttendanceEntryList = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/attendanceEntry/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchAttendanceEntryList', payload)
            } else {
                commit('setAttendanceEntryList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})         
            }
            
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
    
}

export const fetchAttendanceEntryData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/attendanceEntry/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            commit('setAttendanceEntryData', {response: res.data.response, copy: payload.copy})   
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }
        } else {
            commit('resetAttendanceEntryData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitAttendanceEntryData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/attendanceEntry/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchAttendanceEntryData', {
                entry_date: payload.entry_date,
                store_id: payload.store_id
            })
        
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateAttendance = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/attendanceEntry/saveFromPayroll.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});

            if(payload.payroll_id === 0 && payload.payroll_status) {
                dispatch('loadFreshPayrollInformation', {
                    staff_id: payload.staff_id,
                    payroll_period: payload.payroll_period,
                })
            }            
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/attendanceEntry/actions.js